var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cites" },
    [
      _c(
        "div",
        {
          staticClass: "text-left",
          staticStyle: {
            "margin-bottom": "40px",
            color: "rgba(218, 10, 10, 0.7)",
          },
        },
        [
          _vm._v(
            " 说明：当前学者的综合能力分析数据均来源于该学者的引文报告，如果想了解更多维度数据，请点击上方引文报告自行下载查看。 "
          ),
        ]
      ),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.domainRankLoading,
                expression: "domainRankLoading",
              },
            ],
            staticStyle: { width: "60%" },
          },
          [
            _c("div", { staticClass: "flex items-center justify-start" }, [
              _vm._v("领域排名"),
            ]),
            _c(
              "div",
              {
                staticClass: "content-text",
                staticStyle: { "margin-top": "20px" },
              },
              [_vm._v(" " + _vm._s(_vm.domainRankSummary) + " ")]
            ),
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { "margin-top": "26px" },
                    attrs: {
                      "header-cell-style": {
                        background: "#0751AA",
                        borderBottom: "2px solid #EAE9E9",
                        textAlign: "left",
                        color: "#fff",
                      },
                      border: "",
                      data: _vm.domainRankData,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "domainName", label: "荣誉" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "sumScholar", label: "总人数" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "scholarRank", label: "当前学者排名" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "percentage", label: "超越学者占比" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.pubStatisticLoading,
                expression: "pubStatisticLoading",
              },
            ],
            staticStyle: { width: "40%", "margin-left": "60px" },
          },
          [
            _c("div", { staticClass: "flex items-center justify-start" }, [
              _vm._v("论文分析"),
            ]),
            _c(
              "div",
              {
                staticClass: "content-text",
                staticStyle: { "margin-top": "20px" },
              },
              [_vm._v(" " + _vm._s(_vm.pubStatisticSummary) + " ")]
            ),
            _vm.pubStatisticData && _vm.pubStatisticData.length
              ? _c("pub-statistic-chart", {
                  attrs: {
                    "series-data": _vm.pubStatisticData,
                    num: _vm.pubStatisticNum,
                  },
                })
              : _c("el-empty"),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "flex items-center justify-start",
          staticStyle: { "margin-top": "60px" },
        },
        [_vm._v(" 引文分析 ")]
      ),
      _c(
        "p",
        {
          staticClass: "content-text",
          staticStyle: {
            "margin-top": "20px",
            "white-space": "pre-line",
            "line-height": "1.5",
          },
        },
        [_vm._v(" " + _vm._s(_vm.citedStatisticSummary) + " ")]
      ),
      _c("talent-cites-bar", {
        ref: "citesBar",
        attrs: { data: _vm.citesPerYear, "bt-active": 1 },
      }),
      _c("div", { staticClass: "divider-line" }),
      _c("div", { staticClass: "flex items-center justify-start" }, [
        _vm._v("知名学者引用分析"),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.citesLoading,
              expression: "citesLoading",
            },
          ],
          staticClass: "table-view",
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": {
                  background: "#0751AA",
                  borderBottom: "2px solid #EAE9E9",
                  textAlign: "left",
                  color: "#fff",
                },
                border: "",
                data: _vm.tableData,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "荣誉", width: "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "authors", label: "学者" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-wrap",
                            staticStyle: { "padding-left": "20px" },
                          },
                          _vm._l(scope.row.authors, function (item, index) {
                            return _c(
                              "p",
                              { key: index, staticClass: "left-title" },
                              [_vm._v(" " + _vm._s(item.name + ";") + " ")]
                            )
                          }),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }